export default "__VITE_ASSET__DhAVpqTG__"